(() => {
  'use strict';
  const nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  function messageContext() {
    const original = document.getElementById('mot_doux');
    const root = original?.closest('[id^="MainProduct-"]');
    const form = root?.querySelector('product-form form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const value = original?.value;
    if (!form || !variantId || !value || !value.trim()) return null;
    return { variantId: String(variantId), value };
  }

  function withMessage(body, context) {
    if (typeof body === 'string') {
      let data;
      try { data = JSON.parse(body); } catch { return body; }
      const items = Array.isArray(data.items) ? data.items : [data];
      let changed = false;
      for (const item of items) {
        if (String(item.id) !== context.variantId) continue;
        item.properties = { ...(item.properties || {}), 'Votre mot doux': context.value };
        changed = true;
      }
      return changed ? JSON.stringify(data) : body;
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (String(body.get('id')) !== context.variantId) return body;
      const copy = body instanceof FormData ? new FormData() : new URLSearchParams();
      for (const [key, value] of body.entries()) copy.append(key, value);
      copy.set('properties[Votre mot doux]', context.value);
      return copy;
    }
    return body;
  }

  window.fetch = function(input, init) {
    let path;
    try { path = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href).pathname; }
    catch { return nativeFetch.apply(this, arguments); }
    if (/(?:^|\/)cart\/add(?:\.js)?$/.test(path) && init?.body) {
      const context = messageContext();
      if (context) {
        const body = withMessage(init.body, context);
        if (body !== init.body) return nativeFetch.call(this, input, { ...init, body });
      }
    }
    return nativeFetch.apply(this, arguments);
  };
})();
